import config from 'devextreme/core/config';
config({
  licenseKey:
    'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjNiNGZiNDM3LTEzYTAtNDY2Yy05OTRlLTg5YTVkZmYwMzM1NiIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQxCn0=.s5TBG6NNQ915lgn8sCTTCJRJAw8q2z/kDXqvsNHJhtTIzQGLzuyAKd1GsQkLLWSGL4R8QdM2OHpti9sgEoge5fXppM1N8cddd29/0QQ8CGUXCWDEmfO6pSQFCSjrTjfxA/Sd9A==',
});
